import { render, staticRenderFns } from "./KapakHesabiInfo.vue?vue&type=template&id=67f4ccc5&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./KapakHesabiInfo.vue?vue&type=script&lang=ts"
export * from "./KapakHesabiInfo.vue?vue&type=script&lang=ts"
import style0 from "./KapakHesabiInfo.vue?vue&type=style&index=0&id=67f4ccc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4ccc5",
  null
  
)

export default component.exports